import { type ComponentProps, useContext } from 'react';

import { DataContext, Tooltip } from '@visx/xychart';

import './cursor.css';

export const Cursor = ({
  renderTooltip = () => '',
}: {
  renderTooltip?: ComponentProps<typeof Tooltip>['renderTooltip'];
}) => {
  const { theme } = useContext(DataContext) || {};
  const primaryColor = theme?.colors[0];
  return (
    <Tooltip
      snapTooltipToDatumX={true}
      snapTooltipToDatumY={true}
      showVerticalCrosshair={true}
      showSeriesGlyphs={true}
      renderGlyph={({ color }) => <circle r={4} fill={color} stroke="white" strokeWidth={2} />}
      verticalCrosshairStyle={{
        stroke: primaryColor,
        strokeWidth: 1,
      }}
      renderTooltip={renderTooltip}
    />
  );
};
